import { Stack } from "@mui/material";
import { Link } from "react-router-dom";
import { logo } from "../utils/constants";
import SearchBar from "./SearchBar";

const handleClick = () => {
    window.location.pathname = '/';
    document.title = 'PS Tube | Unlimited Discovery';
    document.querySelector('meta[property="og:title"]').setAttribute('content', 'PS Tube | Endless Entertainment');
    document.querySelector('meta[name="description"]').setAttribute('content', 'Dive into a world of captivating videos on PS Tube. Discover trending content, explore new channels, and enjoy endless hours of entertainment. Join our community and start watching today on PS Tube!');
    document.querySelector('meta[property="og:description"]').setAttribute('content', 'Dive into a world of captivating videos on PS Tube. Discover trending content, explore new channels, and enjoy endless hours of entertainment. Join our community and start watching today on PS Tube!');
};

const Navbar = () => (
  <Stack
    direction="row"
    alignItems="center"
    p={2}
    sx={{
      position: "sticky",
      background: "#5484ed",
      top: 0,
      justifyContent: "space-between"
    }}
  >
    <Link style={{ display: "flex", alignItems: "center" }} onClick={handleClick}>
      <img src={logo} alt="logo" height={45} />
    </Link>
    <SearchBar />
  </Stack>
);

export default Navbar;
